var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn statsPage" },
    [
      _c(
        "b-row",
        [
          _c("b-col"),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "div",
                { staticClass: "flexRowEnd" },
                [
                  _vm.isManager && _vm.tabIndex === 1
                    ? _c(
                        "download-csv",
                        {
                          attrs: {
                            data: _vm.formattedScreeningsByOrg,
                            name: "screenings.csv"
                          }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "bgDarkBlue marginR-20",
                              attrs: { variant: "primary" }
                            },
                            [
                              _vm._v(
                                "Download Screenings by Concern Level\n            "
                              ),
                              _c("arrow-down", {
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isManager && _vm.tabIndex === 3
                    ? _c(
                        "download-csv",
                        {
                          attrs: {
                            data: _vm.formattedLaborScreeningsByOrg,
                            name: "screenings.csv"
                          }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "bgDarkBlue marginR-20",
                              attrs: { variant: "primary" }
                            },
                            [
                              _vm._v("Download Screenings by Conclusion "),
                              _c("arrow-down", {
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  color: "white"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapse1",
                          modifiers: { collapse1: true }
                        }
                      ],
                      staticClass: "filterBtn bgDarkBlue",
                      attrs: { variant: "primary" }
                    },
                    [
                      _vm._v("Time"),
                      _c("img", {
                        staticStyle: { "margin-left": "14px" },
                        attrs: {
                          src: require("../../../static/img/filterIcon.png"),
                          width: "17px",
                          height: "11px"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  staticClass: "filterCollapse flexRowEnd marginB-62",
                  attrs: { id: "collapse1" }
                },
                [
                  _c("b-card", [
                    _c("div", { staticClass: "div1" }, [
                      _c("span", [_vm._v("Time")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "div2" },
                      [
                        _c(
                          "b-form-radio-group",
                          {
                            attrs: {
                              id: "radiosBtn",
                              buttons: "",
                              "button-variant": "secondary",
                              name: "radiosBtn"
                            },
                            model: {
                              value: _vm.statisticsTimeInterval,
                              callback: function($$v) {
                                _vm.statisticsTimeInterval = $$v
                              },
                              expression: "statisticsTimeInterval"
                            }
                          },
                          [
                            _c(
                              "b-form-radio",
                              {
                                staticClass: "mx-0 firstBtn",
                                attrs: { value: "Day" }
                              },
                              [_vm._v("Last 30 Days")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-radio",
                              {
                                staticClass: "mx-0",
                                attrs: { value: "Month" }
                              },
                              [_vm._v("Month")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-radio",
                              {
                                staticClass: "mx-0",
                                attrs: { value: "Quarter" }
                              },
                              [_vm._v("Quarter")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-radio",
                              { staticClass: "mx-0", attrs: { value: "Year" } },
                              [_vm._v("Year")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("date-range-picker", {
                          ref: "picker",
                          attrs: {
                            opens: "left",
                            "locale-data": {
                              firstDay: 1,
                              format: "dd-mm-yyyy"
                            },
                            maxDate: new Date(),
                            singleDatePicker: "range",
                            timePicker: false,
                            timePicker24Hour: false,
                            showWeekNumbers: false,
                            showDropdowns: true,
                            autoApply: false,
                            ranges: false
                          },
                          on: { select: _vm.handleSelect },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "date-range-picker__header"
                                    },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            label: "Start Date:",
                                            "label-for": "startDate",
                                            "label-size": "sm"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "mb-0",
                                            attrs: {
                                              "data-vv-name": "startDate",
                                              "data-vv-as": "startDate",
                                              id: "startDate",
                                              size: "sm",
                                              type: "text",
                                              name: "startDate"
                                            },
                                            model: {
                                              value:
                                                _vm.customDateRange.startDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.customDateRange,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "customDateRange.startDate"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            label: "End Date:",
                                            "label-for": "endDate",
                                            "label-size": "sm"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "mb-0",
                                            attrs: {
                                              "data-vv-name": "endDate",
                                              "data-vv-as": "endDate",
                                              id: "endDate",
                                              size: "sm",
                                              type: "text",
                                              name: "endDate"
                                            },
                                            model: {
                                              value:
                                                _vm.customDateRange.endDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.customDateRange,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "customDateRange.endDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "input",
                              fn: function() {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      class: [
                                        "mx-0",
                                        {
                                          active:
                                            _vm.statisticsTimeInterval ===
                                            "Custom"
                                        }
                                      ],
                                      attrs: { variant: "secondary" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Custom\n                    "
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "footer",
                              fn: function(picker) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "date-range-picker__footer"
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "button",
                                            variant: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.saveCustomDateRange(
                                                picker.clickApply
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        Save\n                      "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.customDateRange,
                            callback: function($$v) {
                              _vm.customDateRange = $$v
                            },
                            expression: "customDateRange"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-form-radio",
                          {
                            staticClass: "mx-0 lastBtn",
                            attrs: {
                              button: "",
                              "button-variant": "secondary",
                              value: "All"
                            },
                            model: {
                              value: _vm.statisticsTimeInterval,
                              callback: function($$v) {
                                _vm.statisticsTimeInterval = $$v
                              },
                              expression: "statisticsTimeInterval"
                            }
                          },
                          [_vm._v("All")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          staticClass: "statisticsTabs",
          attrs: { id: "statistics-tabs" },
          model: {
            value: _vm.tabIndex,
            callback: function($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex"
          }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Overall Demographics" } },
            [
              _c(
                "b-row",
                { staticClass: "marginB-14" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c("b-card", { staticClass: "text-white bg-info" }, [
                        _c(
                          "div",
                          { staticClass: "flexRowBetween" },
                          [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.generalCounts.personCount === null
                                    ? 0
                                    : _vm.generalCounts.personCount
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("account-icon", { attrs: { size: 45 } })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("All People")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "text-white bg-danger clickable-card",
                          on: { click: _vm.goToConfirmed }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.generalCounts
                                          .confirmedPersonCount === null
                                          ? 0
                                          : _vm.generalCounts
                                              .confirmedPersonCount
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentConfirmedPersons) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/asterisk-white.png"),
                                  width: "28.83",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Confirmed Victims")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "padding0", attrs: { sm: "12", md: "3" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "clickable-card bg-secondary",
                          on: { click: _vm.goToBlankConfirmed }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.generalCounts
                                          .possiblePersonCount === null
                                          ? 0
                                          : _vm.generalCounts
                                              .possiblePersonCount
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentUnconfirmedPersons) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/pie-black.png"),
                                  width: "30",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Others")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("People over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.personCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "People",
                          apiData: _vm.personCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.personCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.demographicField,
                          callback: function($$v) {
                            _vm.demographicField = $$v
                          },
                          expression: "demographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.personCountsByDemographicError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.personCountsByDemographicError
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("All People")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.personCountsByDemographic,
                                    valueField: "personCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Total People",
                                      apiData: _vm.personCountsByDemographic,
                                      valueField: "personCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Confirmed Victims")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.personCountsByDemographic,
                                    valueField: "confirmedVictimCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Confirmed Victims",
                                      apiData: _vm.personCountsByDemographic,
                                      valueField: "confirmedVictimCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Others")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.personCountsByDemographic,
                                    valueField: "possibleVictimCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Possible Victims",
                                      apiData: _vm.personCountsByDemographic,
                                      valueField: "possibleVictimCount",
                                      groupedBy: _vm.demographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-62" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.demographicByTimeField,
                          callback: function($$v) {
                            _vm.demographicByTimeField = $$v
                          },
                          expression: "demographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("All People")
                      ]),
                      _vm._v(" "),
                      !_vm.personDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.personDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.personDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.personDemographicsByTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Confirmed Victims")
                      ]),
                      _vm._v(" "),
                      !_vm.personDemographicsOverTimeConfirmedError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.personDemographicsByTimeConfirmed,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.personDemographicsByTimeConfirmed,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.personDemographicsOverTimeConfirmedError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Others")
                      ]),
                      _vm._v(" "),
                      !_vm.personDemographicsOverTimeUnconfirmedError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.personDemographicsByTimeUnconfirmed,
                                valueField: "timeInterval",
                                demographicName: _vm.demographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.personDemographicsByTimeUnconfirmed,
                                  valueField: "timeInterval",
                                  demographicName: _vm.demographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.personDemographicsOverTimeUnconfirmedError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "CSE-IT" } },
            [
              _c(
                "div",
                { staticClass: "flexRowAlignCenter marginB-38" },
                [
                  _c(
                    "b-card",
                    { staticClass: "text-white bg-info marginR-42" },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween" },
                        [
                          _c("h1", [
                            _vm._v(
                              _vm._s(
                                _vm.generalCounts.cseitCount === null
                                  ? 0
                                  : _vm.generalCounts.cseitCount
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("account-icon", { attrs: { size: 45 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("CSE-IT Screenings")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.generalCounts.cseitCountAllPerson === null
                                ? 0
                                : _vm.generalCounts.cseitCountAllPerson
                            ) +
                            " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "clickable-card bg-secondary marginR-42",
                      on: { click: _vm.goToNoConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.generalCounts.cseitCountNoConcern === null
                                    ? 0
                                    : _vm.generalCounts.cseitCountNoConcern
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" + _vm._s(_vm.percentCseitNoconcern) + "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/pie-black.png"),
                              width: "30",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("No Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.generalCounts.cseitCountNoConcernPerson === null
                              ? 0
                              : _vm.generalCounts.cseitCountNoConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass:
                        "text-white bg-warning clickable-card marginR-42",
                      on: { click: _vm.goToPossibleConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.generalCounts
                                    .cseitCountPossibleConcern === null
                                    ? 0
                                    : _vm.generalCounts
                                        .cseitCountPossibleConcern
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.percentCseitPossibleConcern) +
                                  "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/alarm-white.png"),
                              width: "36.6",
                              height: "28.3"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Possible Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.generalCounts
                              .cseitCountPossibleConcernPerson === null
                              ? 0
                              : _vm.generalCounts
                                  .cseitCountPossibleConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    {
                      staticClass: "text-white bg-danger clickable-card",
                      on: { click: _vm.goToClearConcern }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flexRowBetween flexRowAlignBaseline" },
                        [
                          _c("div", { staticClass: "flexRowAlignBaseline" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(
                                  _vm.generalCounts.cseitCountClearConcern ===
                                    null
                                    ? 0
                                    : _vm.generalCounts.cseitCountClearConcern
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.percentCseitClearConcern) +
                                  "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/asterisk-white.png"),
                              width: "28.83",
                              height: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v("Clear Concern")
                      ]),
                      _vm._v(" "),
                      _c("h6", { staticClass: "weight-300 marginB0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.generalCounts.cseitCountClearConcernPerson ===
                              null
                              ? 0
                              : _vm.generalCounts.cseitCountClearConcernPerson
                          ) + " unique person(s)"
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isManager && _vm.screeningsByPrimaryOrg.length
                ? _c(
                    "b-card",
                    { staticClass: "padding0" },
                    [
                      _c("b-table", {
                        attrs: {
                          "sticky-header": "350px",
                          striped: true,
                          bordered: false,
                          small: true,
                          fixed: true,
                          responsive: "sm",
                          items: _vm.screeningsByPrimaryOrg,
                          fields: _vm.screeningsTableFields
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "bottom-row",
                              fn: function(data) {
                                return _vm.totalScreeningRow
                                  ? _vm._l(data.fields, function(field, i) {
                                      return _c("td", { key: i }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.totalScreeningRow[field.key]
                                            ) +
                                            "\n            "
                                        )
                                      ])
                                    })
                                  : undefined
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Screenings over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.cseitCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "Screenings",
                          apiData: _vm.cseitCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cseitCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB0 paddingB0" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "cseitDemographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "cseitDemographic"
                        },
                        model: {
                          value: _vm.cseitDemographicField,
                          callback: function($$v) {
                            _vm.cseitDemographicField = $$v
                          },
                          expression: "cseitDemographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.cseitCountsByDemographicError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround marginB-62" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("All Screenings")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData: _vm.cseitCountsByDemographic,
                                        valueField: "cseitCount"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Screenings",
                                          apiData: _vm.cseitCountsByDemographic,
                                          valueField: "cseitCount",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("No Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData: _vm.cseitCountsByDemographic,
                                        valueField: "cseitCountNoConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "No Concern",
                                          apiData: _vm.cseitCountsByDemographic,
                                          valueField: "cseitCountNoConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "flexRowAround marginB-62" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Possible Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData: _vm.cseitCountsByDemographic,
                                        valueField: "cseitCountPossibleConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Possible Concern",
                                          apiData: _vm.cseitCountsByDemographic,
                                          valueField:
                                            "cseitCountPossibleConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c("h4", { staticClass: "text-center" }, [
                                    _vm._v("Clear Concern")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "chart-legend-wrap",
                                    {
                                      attrs: {
                                        type: "pie",
                                        apiData: _vm.cseitCountsByDemographic,
                                        valueField: "cseitCountClearConcern"
                                      }
                                    },
                                    [
                                      _c("pie-chart", {
                                        attrs: {
                                          height: "300",
                                          chartName: "Clear Concern",
                                          apiData: _vm.cseitCountsByDemographic,
                                          valueField: "cseitCountClearConcern",
                                          groupedBy: _vm.cseitDemographicField
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.cseitDemographicByTimeField,
                          callback: function($$v) {
                            _vm.cseitDemographicByTimeField = $$v
                          },
                          expression: "cseitDemographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All Screenings")
                      ]),
                      _vm._v(" "),
                      !_vm.cseitDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.cseitDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.cseitDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cseitDemographicsByTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("No Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.cseitDemographicsOverTimeNoConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.cseitDemographicsByTimeNoConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.cseitDemographicsByTimeNoConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cseitDemographicsOverTimeNoConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Possible Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.cseitDemographicsOverTimePossibleConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.cseitDemographicsByTimePossibleConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.cseitDemographicsByTimePossibleConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cseitDemographicsOverTimePossibleConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Clear Concern")
                      ]),
                      _vm._v(" "),
                      !_vm.cseitDemographicsOverTimeClearConcernError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.cseitDemographicsByTimeClearConcern,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.cseitDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.cseitDemographicsByTimeClearConcern,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.cseitDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cseitDemographicsOverTimeClearConcernError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Indicators")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticStyle: { width: "400px" },
                          attrs: { "label-for": "demographic", horizontal: "" }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.cseitIndicatorOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.cseitIndicatorOption,
                              callback: function($$v) {
                                _vm.cseitIndicatorOption = $$v
                              },
                              expression: "cseitIndicatorOption"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          !_vm.cseitIndicatorsError
                            ? _c("horizontal-bar-chart", {
                                attrs: { apiData: _vm.cseitIndicators }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.cseitIndicatorsError
                            ? _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { attrs: { title: "Lighthouse Indicators" } },
            [
              _c(
                "b-row",
                { staticClass: "marginB-14" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c(
                        "b-card",
                        { staticClass: "text-white bg-info marginR-42" },
                        [
                          _c(
                            "div",
                            { staticClass: "flexRowBetween" },
                            [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.generalCounts.assessmentCount === null
                                      ? 0
                                      : _vm.generalCounts.assessmentCount
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("account-icon", { attrs: { size: 45 } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("All Lighthouse Screenings")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.generalCounts.assessmentCountAllPerson ===
                                  null
                                  ? 0
                                  : _vm.generalCounts.assessmentCountAllPerson
                              ) + " unique person(s)"
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "padding0 marginR-42",
                      attrs: { sm: "12", md: "3" }
                    },
                    [
                      _c("b-card", { staticClass: "bg-secondary marginR-42" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flexRowBetween flexRowAlignBaseline"
                          },
                          [
                            _c("div", { staticClass: "flexRowAlignBaseline" }, [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.generalCounts
                                      .assessmentCountNotEnoughInfo === null
                                      ? 0
                                      : _vm.generalCounts
                                          .assessmentCountNotEnoughInfo
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("h5", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.percentAssessmentNotenoughinfo) +
                                    "%)"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/pie-black.png"),
                                width: "30",
                                height: "30"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("Not Enough Info")
                        ]),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.generalCounts
                                  .assessmentCountNotEnoughInfoPerson === null
                                  ? 0
                                  : _vm.generalCounts
                                      .assessmentCountNotEnoughInfoPerson
                              ) +
                              " unique person(s)"
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "padding0", attrs: { sm: "12", md: "3" } },
                    [
                      _c("b-card", { staticClass: "text-white bg-warning" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flexRowBetween flexRowAlignBaseline"
                          },
                          [
                            _c("div", { staticClass: "flexRowAlignBaseline" }, [
                              _c("h1", [
                                _vm._v(
                                  _vm._s(
                                    _vm.generalCounts
                                      .assessmentCountPossible === null
                                      ? 0
                                      : _vm.generalCounts
                                          .assessmentCountPossible
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("h5", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.percentAssessmentPossible) +
                                    "%)"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/alarm-white.png"),
                                width: "36.6",
                                height: "28.3"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v("Possible Victim")
                        ]),
                        _vm._v(" "),
                        _c("h6", { staticClass: "weight-300 marginB0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.generalCounts
                                  .assessmentCountPossiblePerson === null
                                  ? 0
                                  : _vm.generalCounts
                                      .assessmentCountPossiblePerson
                              ) +
                              " unique person(s)"
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Lighthouse Screenings over Time")
                  ]),
                  _vm._v(" "),
                  !_vm.assessmentCountsByTimeError
                    ? _c("main-chart", {
                        staticClass: "chart-wrapper",
                        staticStyle: { height: "200px" },
                        attrs: {
                          height: "200",
                          chartName: "Assessments",
                          apiData: _vm.assessmentCountsByTime
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.assessmentCountsByTimeError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics by Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.assessmentDemographicField,
                          callback: function($$v) {
                            _vm.assessmentDemographicField = $$v
                          },
                          expression: "assessmentDemographicField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.assessmentByDemographicError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.assessmentByDemographicError
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("All Lighthouse Screenings")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.assessmentCountsByDemographic,
                                    valueField: "assessmentCount"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Total People",
                                      apiData:
                                        _vm.assessmentCountsByDemographic,
                                      valueField: "assessmentCount",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Not Enough Information")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.assessmentCountsByDemographic,
                                    valueField: "assessmentCountNotEnoughInfo"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Possible Victims",
                                      apiData:
                                        _vm.assessmentCountsByDemographic,
                                      valueField:
                                        "assessmentCountNotEnoughInfo",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "4" } },
                            [
                              _c("h4", { staticClass: "text-center" }, [
                                _vm._v("Possible Victim")
                              ]),
                              _vm._v(" "),
                              _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "pie",
                                    apiData: _vm.assessmentCountsByDemographic,
                                    valueField: "assessmentCountPossible"
                                  }
                                },
                                [
                                  _c("pie-chart", {
                                    staticClass: "chart-wrapper",
                                    attrs: {
                                      height: "300",
                                      chartName: "Confirmed Victims",
                                      apiData:
                                        _vm.assessmentCountsByDemographic,
                                      valueField: "assessmentCountPossible",
                                      groupedBy: _vm.assessmentDemographicField
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { staticClass: "marginB-14" },
                [
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Demographics over Time")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "pillSelector",
                      attrs: {
                        "label-cols": "4",
                        "label-text-align": "center",
                        "label-size": "lg",
                        "label-class": "addpersonlabel",
                        label: "Group By",
                        "label-for": "demographic",
                        horizontal: ""
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.biographicOptions,
                          id: "demographic"
                        },
                        model: {
                          value: _vm.assessmentDemographicByTimeField,
                          callback: function($$v) {
                            _vm.assessmentDemographicByTimeField = $$v
                          },
                          expression: "assessmentDemographicByTimeField"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("All Lighthouse Screenings")
                      ]),
                      _vm._v(" "),
                      !_vm.assessmentDemographicsByTimeError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData: _vm.assessmentDemographicsByTime,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.assessmentDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: { height: "200px" },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData: _vm.assessmentDemographicsByTime,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.assessmentDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.assessmentDemographicsByTimeError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "marginB-62" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Not Enough Information")
                      ]),
                      _vm._v(" "),
                      !_vm.assessmentDemographicsOverTimeNoInfoError
                        ? _c(
                            "chart-legend-wrap",
                            {
                              attrs: {
                                type: "stacked-line",
                                apiData:
                                  _vm.assessmentDemographicsByTimeNoInfoVictims,
                                valueField: "timeInterval",
                                demographicName:
                                  _vm.assessmentDemographicByTimeField,
                                colorValues: _vm.colorValues
                              }
                            },
                            [
                              _c("stacked-line-chart", {
                                staticClass: "chart-wrapper",
                                staticStyle: {
                                  height: "200px",
                                  "margin-top": "40px"
                                },
                                attrs: {
                                  height: "200",
                                  chartName: "Demographics over Time",
                                  apiData:
                                    _vm.assessmentDemographicsByTimeNoInfoVictims,
                                  valueField: "timeInterval",
                                  demographicName:
                                    _vm.assessmentDemographicByTimeField,
                                  colorValues: _vm.colorValues
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.assessmentDemographicsOverTimeNoInfoError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "card-title marginB-32" }, [
                    _vm._v("Possible Victim")
                  ]),
                  _vm._v(" "),
                  !_vm.assessmentDemographicsOverTimePossibleError
                    ? _c(
                        "chart-legend-wrap",
                        {
                          attrs: {
                            type: "stacked-line",
                            apiData:
                              _vm.assessmentDemographicsByTimePossibleVictims,
                            valueField: "timeInterval",
                            demographicName:
                              _vm.assessmentDemographicByTimeField,
                            colorValues: _vm.colorValues
                          }
                        },
                        [
                          _c("stacked-line-chart", {
                            staticClass: "chart-wrapper",
                            staticStyle: {
                              height: "200px",
                              "margin-top": "40px"
                            },
                            attrs: {
                              height: "200",
                              chartName: "Demographics over Time",
                              apiData:
                                _vm.assessmentDemographicsByTimePossibleVictims,
                              valueField: "timeInterval",
                              demographicName:
                                _vm.assessmentDemographicByTimeField,
                              colorValues: _vm.colorValues
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.assessmentDemographicsOverTimePossibleError
                    ? _c("p", [_vm._v("There is no data for this chart.")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v("Indicators")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flexRowJustifyCenter" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticStyle: { width: "450px" },
                          attrs: { "label-for": "demographic", horizontal: "" }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.assmentIndicatorOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.assessmentIndicatorOption,
                              callback: function($$v) {
                                _vm.assessmentIndicatorOption = $$v
                              },
                              expression: "assessmentIndicatorOption"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          !_vm.assessmentIndicatorsError
                            ? _c("horizontal-bar-chart", {
                                attrs: { apiData: _vm.assessmentIndicators }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.assessmentIndicatorsError
                            ? _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isUserInLA
            ? _c(
                "b-tab",
                { attrs: { title: "Labor Screening" } },
                [
                  _c(
                    "div",
                    { staticClass: "flexRowAlignCenter marginB-38" },
                    [
                      _c(
                        "b-card",
                        { staticClass: "text-white bg-info marginR-42" },
                        [
                          _c(
                            "div",
                            { staticClass: "flexRowBetween" },
                            [
                              _c("h1", [
                                _vm._v(_vm._s(_vm.generalCounts.lsCount))
                              ]),
                              _vm._v(" "),
                              _c("account-icon", { attrs: { size: 45 } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Labor Screenings")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.generalCounts.lsCountAllPerson) +
                                " unique person(s)"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass: "clickable-card bg-secondary marginR-42",
                          on: { click: _vm.goToLSNotEnoughInfo }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.generalCounts.lsCountNotEnoughInfo
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentLsNotEnoughInfo) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/pie-black.png"),
                                  width: "30",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Not Enough Info")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.generalCounts.lsCountNotEnoughInfoPerson
                                ) +
                                " unique person(s)"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass:
                            "text-white bg-warning clickable-card marginR-42",
                          on: { click: _vm.goToLSVulnerable }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.generalCounts.lsCountVulnerable
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentLsVulnerable) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/alarm-white.png"),
                                  width: "36.6",
                                  height: "28.3"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Level 1: Concern")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.generalCounts.lsCountVulnerablePerson
                                ) +
                                " unique person(s)"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass: "text-white bg-danger clickable-card",
                          on: { click: _vm.goToLSHighlyVulnerable }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flexRowBetween flexRowAlignBaseline"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flexRowAlignBaseline" },
                                [
                                  _c("h1", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.generalCounts
                                          .lsCountHighlyVulnerable
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("h5", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.percentLsHighlyVulnerable) +
                                        "%)"
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/asterisk-white.png"),
                                  width: "28.83",
                                  height: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v("Level 2: Indicated")
                          ]),
                          _vm._v(" "),
                          _c("h6", { staticClass: "weight-300 marginB0" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.generalCounts
                                    .lsCountHighlyVulnerablePerson
                                ) +
                                " unique person(s)"
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isManager && _vm.laborScreeningsByPrimaryOrg.length
                    ? _c(
                        "div",
                        { staticClass: "marginB-32" },
                        [
                          _c("b-table", {
                            attrs: {
                              "sticky-header": "350px",
                              striped: true,
                              bordered: false,
                              small: true,
                              fixed: true,
                              responsive: "sm",
                              items: _vm.laborScreeningsByPrimaryOrg,
                              fields: _vm.laborScreeningsTableFields
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "bottom-row",
                                  fn: function(data) {
                                    return _vm.totalLaborScreeningRow
                                      ? _vm._l(data.fields, function(field, i) {
                                          return _c("td", { key: i }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.totalLaborScreeningRow[
                                                    field.key
                                                  ]
                                                ) +
                                                "\n            "
                                            )
                                          ])
                                        })
                                      : undefined
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "marginB-14" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Screenings over Time")
                      ]),
                      _vm._v(" "),
                      !_vm.lsCountsByTimeError
                        ? _c("main-chart", {
                            staticClass: "chart-wrapper",
                            staticStyle: { height: "200px" },
                            attrs: {
                              height: "200",
                              chartName: "Screenings",
                              apiData: _vm.lsCountsByTime
                            }
                          })
                        : _c("p", [_vm._v("There is no data for this chart.")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "marginB-14" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Demographics by Status")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "pillSelector",
                          attrs: {
                            "label-cols": "4",
                            "label-text-align": "center",
                            "label-size": "lg",
                            "label-class": "addpersonlabel",
                            label: "Group By",
                            "label-for": "lsDemographic",
                            horizontal: ""
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.biographicOptions,
                              id: "lsDemographic"
                            },
                            model: {
                              value: _vm.laborScreeningDemographicField,
                              callback: function($$v) {
                                _vm.laborScreeningDemographicField = $$v
                              },
                              expression: "laborScreeningDemographicField"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lsCountsByDemographicError
                        ? _c("p", [_vm._v("There is no data for this chart.")])
                        : _c(
                            "div",
                            [
                              _c(
                                "b-row",
                                { staticClass: "flexRowAround marginB-62" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("h4", { staticClass: "text-center" }, [
                                        _vm._v("All Screenings")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "chart-legend-wrap",
                                        {
                                          attrs: {
                                            type: "pie",
                                            apiData: _vm.lsCountsByDemographic,
                                            valueField: "lsCount"
                                          }
                                        },
                                        [
                                          _c("pie-chart", {
                                            attrs: {
                                              height: "300",
                                              chartName: "Screenings",
                                              apiData:
                                                _vm.lsCountsByDemographic,
                                              valueField: "lsCount",
                                              groupedBy:
                                                _vm.laborScreeningDemographicField
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("h4", { staticClass: "text-center" }, [
                                        _vm._v("Not Enough Info")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "chart-legend-wrap",
                                        {
                                          attrs: {
                                            type: "pie",
                                            apiData: _vm.lsCountsByDemographic,
                                            valueField: "lsCountNotEnoughInfo"
                                          }
                                        },
                                        [
                                          _c("pie-chart", {
                                            attrs: {
                                              height: "300",
                                              chartName: "Not Enough Info",
                                              apiData:
                                                _vm.lsCountsByDemographic,
                                              valueField:
                                                "lsCountNotEnoughInfo",
                                              groupedBy:
                                                _vm.laborScreeningDemographicField
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "flexRowAround" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("h4", { staticClass: "text-center" }, [
                                        _vm._v("Level 1: Concern")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "chart-legend-wrap",
                                        {
                                          attrs: {
                                            type: "pie",
                                            apiData: _vm.lsCountsByDemographic,
                                            valueField: "lsCountVulnerable"
                                          }
                                        },
                                        [
                                          _c("pie-chart", {
                                            attrs: {
                                              height: "300",
                                              chartName: "Level 1: Concern",
                                              apiData:
                                                _vm.lsCountsByDemographic,
                                              valueField: "lsCountVulnerable",
                                              groupedBy:
                                                _vm.laborScreeningDemographicField
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "4" } },
                                    [
                                      _c("h4", { staticClass: "text-center" }, [
                                        _vm._v("Level 2: Indicated")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "chart-legend-wrap",
                                        {
                                          attrs: {
                                            type: "pie",
                                            apiData: _vm.lsCountsByDemographic,
                                            valueField:
                                              "lsCountHighlyVulnerable"
                                          }
                                        },
                                        [
                                          _c("pie-chart", {
                                            attrs: {
                                              height: "300",
                                              chartName: "Level 2: Indicated",
                                              apiData:
                                                _vm.lsCountsByDemographic,
                                              valueField:
                                                "lsCountHighlyVulnerable",
                                              groupedBy:
                                                _vm.laborScreeningDemographicField
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "marginB-14" },
                    [
                      _c("h4", { staticClass: "card-title marginB-32" }, [
                        _vm._v("Demographics over Time")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "pillSelector",
                          attrs: {
                            "label-cols": "4",
                            "label-text-align": "center",
                            "label-size": "lg",
                            "label-class": "addpersonlabel",
                            label: "Group By",
                            "label-for": "demographic",
                            horizontal: ""
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "lg",
                              options: _vm.biographicOptions,
                              id: "demographic"
                            },
                            model: {
                              value: _vm.lsDemographicByTimeField,
                              callback: function($$v) {
                                _vm.lsDemographicByTimeField = $$v
                              },
                              expression: "lsDemographicByTimeField"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "marginB-62" },
                        [
                          _c("h4", { staticClass: "card-title marginB-32" }, [
                            _vm._v("All Screenings")
                          ]),
                          _vm._v(" "),
                          !_vm.lsDemographicsByTimeError
                            ? _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "stacked-line",
                                    apiData: _vm.lsDemographicsByTime,
                                    valueField: "timeInterval",
                                    demographicName:
                                      _vm.lsDemographicByTimeField,
                                    colorValues: _vm.colorValues
                                  }
                                },
                                [
                                  _c("stacked-line-chart", {
                                    staticClass: "chart-wrapper",
                                    staticStyle: { height: "200px" },
                                    attrs: {
                                      height: "200",
                                      chartName: "Demographics over Time",
                                      apiData: _vm.lsDemographicsByTime,
                                      valueField: "timeInterval",
                                      demographicName:
                                        _vm.lsDemographicByTimeField,
                                      colorValues: _vm.colorValues
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "marginB-62" },
                        [
                          _c("h4", { staticClass: "card-title marginB-32" }, [
                            _vm._v("Not Enough Info")
                          ]),
                          _vm._v(" "),
                          !_vm.lsDemographicsByTimeError
                            ? _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "stacked-line",
                                    apiData: _vm.lsDemographicsByTime,
                                    valueField: "timeInterval",
                                    demographicName:
                                      _vm.lsDemographicByTimeField,
                                    demographicTotalKey:
                                      "demographicNotEnoughInfo",
                                    colorValues: _vm.colorValues
                                  }
                                },
                                [
                                  _c("stacked-line-chart", {
                                    staticClass: "chart-wrapper",
                                    staticStyle: { height: "200px" },
                                    attrs: {
                                      height: "200",
                                      chartName: "Demographics over Time",
                                      apiData: _vm.lsDemographicsByTime,
                                      valueField: "timeInterval",
                                      demographicTotalKey:
                                        "demographicNotEnoughInfo",
                                      demographicName:
                                        _vm.lsDemographicByTimeField,
                                      colorValues: _vm.colorValues
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "marginB-62" },
                        [
                          _c("h4", { staticClass: "card-title marginB-32" }, [
                            _vm._v("Level 1: Concern")
                          ]),
                          _vm._v(" "),
                          !_vm.lsDemographicsByTimeError
                            ? _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "stacked-line",
                                    apiData: _vm.lsDemographicsByTime,
                                    valueField: "timeInterval",
                                    demographicName:
                                      _vm.lsDemographicByTimeField,
                                    demographicTotalKey:
                                      "demographicVulnerable",
                                    colorValues: _vm.colorValues
                                  }
                                },
                                [
                                  _c("stacked-line-chart", {
                                    staticClass: "chart-wrapper",
                                    staticStyle: { height: "200px" },
                                    attrs: {
                                      height: "200",
                                      chartName: "Demographics over Time",
                                      apiData: _vm.lsDemographicsByTime,
                                      valueField: "timeInterval",
                                      demographicTotalKey:
                                        "demographicVulnerable",
                                      demographicName:
                                        _vm.lsDemographicByTimeField,
                                      colorValues: _vm.colorValues
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("h4", { staticClass: "card-title marginB-32" }, [
                            _vm._v("Level 2: Indicated")
                          ]),
                          _vm._v(" "),
                          !_vm.lsDemographicsByTimeError
                            ? _c(
                                "chart-legend-wrap",
                                {
                                  attrs: {
                                    type: "stacked-line",
                                    apiData: _vm.lsDemographicsByTime,
                                    valueField: "timeInterval",
                                    demographicName:
                                      _vm.lsDemographicByTimeField,
                                    demographicTotalKey:
                                      "demographicHighlyVulnerable",
                                    colorValues: _vm.colorValues
                                  }
                                },
                                [
                                  !_vm.lsDemographicsByTimeError
                                    ? _c("stacked-line-chart", {
                                        staticClass: "chart-wrapper",
                                        staticStyle: { height: "200px" },
                                        attrs: {
                                          height: "200",
                                          chartName: "Demographics over Time",
                                          apiData: _vm.lsDemographicsByTime,
                                          valueField: "timeInterval",
                                          demographicTotalKey:
                                            "demographicHighlyVulnerable",
                                          demographicName:
                                            _vm.lsDemographicByTimeField,
                                          colorValues: _vm.colorValues
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c("p", [
                                _vm._v("There is no data for this chart.")
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    [
                      _c("h4", { staticClass: "card-title mb-0" }, [
                        _vm._v("Indicators")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "justify-content-center" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { width: "420px" },
                              attrs: {
                                "label-for": "demographic",
                                horizontal: ""
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.laborScreeningIndicatorOptions,
                                  id: "demographic"
                                },
                                model: {
                                  value: _vm.laborScreeningIndicatorOption,
                                  callback: function($$v) {
                                    _vm.laborScreeningIndicatorOption = $$v
                                  },
                                  expression: "laborScreeningIndicatorOption"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12" } },
                            [
                              _c(
                                "b-tabs",
                                [
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Ends" } },
                                    [
                                      !_vm.lsIndicatorsError
                                        ? _c("horizontal-bar-chart", {
                                            attrs: {
                                              transformKeyFunction:
                                                _vm.transformLaborScreeningIndicatorKey,
                                              apiData:
                                                _vm.laborScreeningIndicatorsEnds
                                            }
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              "There is no data for this chart."
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Means" } },
                                    [
                                      !_vm.lsIndicatorsError
                                        ? _c("horizontal-bar-chart", {
                                            attrs: {
                                              transformKeyFunction:
                                                _vm.transformLaborScreeningIndicatorKey,
                                              apiData:
                                                _vm.laborScreeningIndicatorsMeans
                                            }
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              "There is no data for this chart."
                                            )
                                          ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    { attrs: { title: "Process" } },
                                    [
                                      !_vm.lsIndicatorsError
                                        ? _c("horizontal-bar-chart", {
                                            attrs: {
                                              transformKeyFunction:
                                                _vm.transformLaborScreeningIndicatorKey,
                                              apiData:
                                                _vm.laborScreeningIndicatorsProcess
                                            }
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              "There is no data for this chart."
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b6063aa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b6063aa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Statistics.vue
// module id = 1793
// module chunks = 0